import { AccessErrorTypes, AccessErrorActionTypes } from "./accessErrorTypes";

export function setAccessError(hasAccessError: boolean): AccessErrorActionTypes {
	return {
		type: AccessErrorTypes.SET_ACCESS_ERROR,
		payload: { hasAccessError },
	};
}

export function clearAccessError(): AccessErrorActionTypes {
	return {
		type: AccessErrorTypes.CLEAR_ACCESS_ERROR,
	};
}
